export default "__VITE_ASSET__acc3e711__"